"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var template_1 = __importDefault(require("../helpers/template"));
var log_1 = __importDefault(require("../helpers/log"));
var slider_1 = __importDefault(require("../helpers/slider"));
var query_1 = __importDefault(require("../helpers/query"));
var reveal_1 = __importDefault(require("../helpers/reveal"));
var RecentlyViewed = /** @class */ (function () {
    function RecentlyViewed() {
        this.config = {
            productDir: '/products/',
            localStorageKey: 'recentlyViewed',
            maxProducts: 6,
            minProducts: 3,
            view: 'recently-viewed',
            content: '[data-recently-viewed-content]',
            slider: '[data-recently-viewed-slider]',
            hideClass: 'hide',
            container: '[data-recently-viewed]'
        };
    }
    RecentlyViewed.prototype.init = function () {
        if (window.location.pathname.includes(this.config.productDir))
            this.updateLocalStorage();
        var nodeList = document.querySelectorAll(this.config.container);
        if (nodeList.length) {
            this.renderAll(nodeList);
        }
    };
    RecentlyViewed.prototype.renderAll = function (nodeList) {
        var _this = this;
        var handles;
        try {
            handles = JSON.parse(window.localStorage.getItem(this.config.localStorageKey));
        }
        catch (error) {
            log_1.default.error(error);
        }
        if (handles && handles.length >= this.config.minProducts)
            nodeList.forEach(function (node) { return _this.render(node, handles); });
    };
    RecentlyViewed.prototype.render = function (node, handles) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = query_1.default.buildURL({
                            type: 'product',
                            operator: 'OR',
                            handles: handles
                        });
                        return [4 /*yield*/, template_1.default.getAndUpdateHTML({
                                node: node,
                                content: this.config.content,
                                url: url,
                                view: this.config.view
                            })];
                    case 1:
                        _a.sent();
                        this.slider(node);
                        reveal_1.default.closestHideClassName(node);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        log_1.default.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecentlyViewed.prototype.slider = function (node) {
        var sliderNode = node.querySelector(this.config.slider);
        if (sliderNode)
            slider_1.default.init(sliderNode, { items: 2.5 });
    };
    RecentlyViewed.prototype.reveal = function (node) {
        node.classList.remove(this.config.hideClass);
    };
    RecentlyViewed.prototype.updateLocalStorage = function () {
        try {
            var paths = window.location.pathname.split('/');
            var handle = paths[paths.length - 1];
            var localHandles = JSON.parse(window.localStorage.getItem(this.config.localStorageKey));
            var handles = new Set(localHandles);
            if (handles.size == this.config.maxProducts)
                handles.delete(handles.values().next().value);
            handles.add(handle);
            window.localStorage.setItem(this.config.localStorageKey, JSON.stringify(Array.from(handles)));
        }
        catch (error) {
            console.error(error);
        }
    };
    return RecentlyViewed;
}());
exports.default = new RecentlyViewed();
